import React, { Component } from 'react';
import ArticleListMeta from './article-list-meta';
import DocumentList from './article-documents';

export default class ArticleItem extends Component {
	renderAssets( assets, postLink ) {
		if ( this.hasAssets( assets ) ) {
			return (
				<DocumentList assets={ assets } postLink={ postLink } />
			);
		}
	}

	hasAssets( assets ) {
		return 'undefined' !== typeof assets && assets.length;
	}

	getExcerpt( post ) {
		return 'undefined' !== typeof post.excerpt
			? post.excerpt.rendered
			: post.content.rendered.substring( 0, 140 );
	}

	getTagList( tags ) {
		if ( 'undefined' !== typeof tags && tags.length ) {
			return '<strong>Tags:</strong>'+ tags;
		}

		return '';
	}

	getSideColumn( post ) {
		const articles = post.article_titles;
		const href = post.link;

		if ( post.format === 'aside' ) {
			return <div className="col-sm-4 aside-present-value">
				<h4 className="article-contents-header">Contents</h4>
				<ul className="article-contents-ul">

					{ articles.map( ( value, index ) => {
						return <a href={ href } className="article-contents-link">
							<li className="article-contents-list" key={ index }>{ value }</li>
						</a>;
					} ) }
				</ul>
			</div>;
		} else {
			return <div className="col-sm-4 attached-documents">
				<h4 className="assets-list-title">Documents ({ ('undefined' !== typeof  this.props.post.assets
				                                               ) && this.props.post.assets.length > 0
					? this.props.post.assets.length
					: '0' }) <span className="sr-only">for { this.props.post.title.rendered }</span></h4>
				{ this.renderAssets( this.props.post.assets, href ) }
			</div>;
		}
	}

	render() {
		return (
			<article className="two-col-content-panel">
				<div className="col-sm-8">
					<div role="tabpanel" className="tab-pane fade in active">
						<header>
							<ArticleListMeta category_ids={ this.props.post.categories }
							                 date={ this.props.post.date } post_id={ this.props.post.id } />
							<span dangerouslySetInnerHTML={ {
								__html: this.props.post.prioritize_search
									? '<b class="prioritize-search-result"><b>Prioritize/Featured Result</b>'
									: ''
							} }></span>

							<h3 className="entry-title">
								<a href={ this.props.post.link } dangerouslySetInnerHTML={ { __html: this.props.post.title.rendered } } />
							</h3>
						</header>
						<div className="entry-content" dangerouslySetInnerHTML={ { __html: this.getExcerpt( this.props.post ) } } />
						<div className="default-tags-list" dangerouslySetInnerHTML={ { __html: this.getTagList( this.props.post.tag_list ) } } />
					</div>
				</div>
				{ this.getSideColumn( this.props.post ) }
			</article>
		);
	}
}